import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import Filtericon from "../../assets/svg/filter-icon.svg";
import Sidebar from "../../Components/Sidebar/Sidebar";
import CustomizeTime from "../Drawers/CustomizeTime";
import moment from "moment";
import DateFilter from "../Dropdown/DateFilter";

import { servicePost } from "../../helper/api";
import CommonModal from "../Modals/CommonModal";
import Navbar from "../../Components/Navbar/Navbar";
import ChangeStatus from "../Dropdown/ChangeStatus";
import TwofaDisableDrawer from "../Drawers/TwofaDisableDrawer";
import ConfirmationModal from "../Modals/ConfirmationModal";
import KYCResetModal from "../Modals/KycResetModal";

import Dropdown from "../Dropdown/Dropdown";
import { getDeviceInfo } from "../../helper/helper";
import { useDispatch, useSelector } from "react-redux";
import { setServiceType } from "../../redux/features/serviceTypeSlice";
import { resetSpecificDropdown } from "../../redux/features/dropdownSlice";
import { resetSpecificFormData } from "../../redux/features/formSlice";
import { clearFlooringPrices } from "../../redux/features/flooringPriceSlice";
import { emptyCartItem } from "../../redux/features/cartSlice";
import SpecialityModal from "../CreateOrder/modals/SpecialityModal";
import {
  ShimmerCircularImage,
  ShimmerText,
  ShimmerThumbnail,
  ShimmerTable,
} from "react-shimmer-effects";

// Status DropDown Data
const ApplicationStatusDropdown = [
  {
    name: "Approved",
  },
  {
    name: "Rejected",
  },
];

// Status DropDown Data
const CreateServiceData = [
  {
    name: "Commercial",
  },

  {
    name: "Residential",
  },
];

// Cleaner DropDown Values
const TypeDropData = [
  {
    name: "All",
  },
  {
    name: "Commercial",
  },
  {
    name: "Residential",
  },
];

// Status DropDown Data
const StatusDropdown = [
  {
    name: "All",
  },

  {
    name: "Refund",
  },

  {
    name: "Processing",
  },
  {
    name: "Accepted",
  },
  {
    name: "Completed",
  },
  {
    name: "Cancelled",
  },
];

// Payment DropDown Data
const paymentDropData = [
  {
    name: "All",
  },
  {
    name: "Paid",
  },
  {
    name: "unpaid",
  },
];

const AccountDetail = () => {
  const [redirectPath, setRedirectPath] = useState();
  const [showSpecialityModal, setShowSpecialityModal] = useState(false);
  const [orderServiceType, setOrderServiceType] = useState("");
  const [modalShow, setModalShow] = useState(false);
  const [kycmodalShow, setkycModalShow] = useState(false);
  const [showCommanModal, setShowCommanModal] = useState(false);
  const [checkedIp, setCheckedIp] = useState("customer");
  const [copyMsg, setCopyMsg] = useState("Copy");
  const [filterStartDate, setFilterStartDate] = useState("");
  const [filterEndDate, setFilterEndDate] = useState("");
  const [selectedDate, setSelectedDate] = useState("");
  const [filterDate, setFilterDate] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");
  const [selectedCrypto, setSelectedCrypto] = useState("");
  const [selectedPayment, setSelectedPayment] = useState("");
  const [applicationStatus, setApplicationStatus] = useState("");
  const [selectedType, setSelectedType] = useState("");
  const [selectedTableStatus, setSelectedTableStatus] = useState("");
  const [listTransaction, setListTransaction] = useState();
  const [transactionId, setTransactionId] = useState("");
  const [isCopyTooltipVisible, setCopyToolTipVisibility] = useState(false);
  const [userDetail, setUserDetail] = useState();
  const [shimmerLoading, setShimmerLoading] = useState(true);

  console.log("userDetail", userDetail);

  const [listActivity, setListActivity] = useState();
  const [commanModalText, setCommanModalText] = useState("");
  console.log("listTransaction", listTransaction);

  const serviceType = useSelector((state) => state.serviceType.serviceType);
  const carts = useSelector((state) => state.allCart.carts);

  const { state } = useLocation();
  const { AccountId } = state;
  console.log("AccountId", AccountId);

  // Redirect create order pages According to selected Type
  const dispatch = useDispatch();

  // get AuthToken from localStorage
  const authToken = localStorage.getItem("token");
  const notification = "";

  useEffect(() => {
    if (orderServiceType == "Residential") {
      navigate("/create-order-services", {
        state: { AccountId: AccountId },
      });
      dispatch(setServiceType(orderServiceType));
    }

    if (orderServiceType == "Commercial") {
      navigate("/services-commercial", {
        state: { AccountId: AccountId },
      });
      dispatch(setServiceType(orderServiceType));
    }
  }, [orderServiceType]);

  useEffect(() => {
    if (isCopyTooltipVisible == true) {
      setCopyMsg("Copied");
    }
    setTimeout(() => {
      setCopyMsg("Copy");
      setCopyToolTipVisibility(false);
    }, 3000);
  }, [isCopyTooltipVisible]);

  const navigate = useNavigate();
  const goToAccount = () => {
    navigate("/account");
  };

  const goToAccountTransaction = () => {
    navigate("/account-transation");
  };

  const getUserDetail = async () => {
    try {
      const userDetailRes = await servicePost(
        "adminauth/userDetail",
        {
          accountId: AccountId,
        },
        notification,
        authToken
      );
      console.log("userDetailRes=", userDetailRes);
      setShimmerLoading(false);
      setUserDetail(userDetailRes.data);
      setListActivity(userDetailRes?.activities.reverse());
    } catch (error) {
      console.log("error", error);
    }
  };

  const getAllTransaction = async () => {
    try {
      const getAllTx = await servicePost(
        "adminbooking/getAllBookingsUser",
        {
          // accountId: accountDetail?.id,
          accountId: AccountId,
        },
        notification,
        authToken
      );

      console.log("ClientTx", getAllTx.data);

      const sortedUsers = getAllTx.data.sort(
        (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
      );
      setListTransaction(sortedUsers);
      // setListTransaction(getAllTx.data.reverse());
    } catch (error) {}
  };

  useEffect(() => {
    if (AccountId) {
      // getActivty();
      getAllTransaction();
      getUserDetail();
    }
  }, [AccountId]);

  const updateDocusign = async () => {
    const updateDucusingRes = await servicePost(
      "api/v1/admin/updateDocusign",
      {
        accountId: AccountId,
      },
      notification,
      authToken
    );
    setModalShow(true);
    // console.log("updateDucusingRes", updateDucusingRes.data);
    localStorage.setItem(
      "accountDetail",
      JSON.stringify(updateDucusingRes.data)
    );
    // console.log("updateDucusingRes", updateDucusingRes);
  };

  const reqDisable = async () => {
    try {
      const disbale = await servicePost(
        "api/v1/admin/admindisabletwofa",
        {
          user: userDetail.Email,
        },
        notification,
        authToken
      );

      if (disbale.message == "SUCCESS") {
        setShowCommanModal(true);
      }
    } catch (error) {
      console.log("err".error);
    }
  };
  /////////////
  const resetKYC = async () => {
    setkycModalShow(true);
  };
  ////////
  // useEffect(() => {
  //   updateDocusign();
  // }, [userDetail]);
  // console.log(userDetail?.TwoFactorEnabled);

  const handleTableStatusChange = (status) => {
    setModalShow(true);
    setSelectedTableStatus(status);
  };

  const handleDateChange = (selectedDate) => {
    setSelectedDate(selectedDate);

    if (selectedDate == "Customized Calender") {
      document.getElementById("customizedate").click();
      setFilterDate("");
    } else if (selectedDate == "Past 90 Days") {
      var date = new Date();
      date.setDate(date.getDate() - 90);
      setFilterDate(date);
      setFilterStartDate("");
      setFilterEndDate("");
    } else if (selectedDate == "Past 30 Days") {
      var date = new Date();
      date.setDate(date.getDate() - 30);
      setFilterDate(date);
      setFilterStartDate("");
      setFilterEndDate("");
    } else if (selectedDate == "Past 7 Days") {
      var date = new Date();
      date.setDate(date.getDate() - 7);
      setFilterDate(date);
      setFilterStartDate("");
      setFilterEndDate("");
    } else {
      setFilterDate("");
      setFilterStartDate("");
      setFilterEndDate("");
    }
  };

  const getStatusImage = (status) => {
    if (status === "Pending") {
      return "./images/icons/status-icon-1.png";
    } else if (status === "Processing") {
      return "./images/icons/status-icon-2.png";
    } else if (status === "Complete") {
      return "./images/icons/status-icon-3.png";
    } else if (status === "Cancelled") {
      return "./images/icons/status-icon-4.png";
    } else {
      return <span>Status not available</span>;
    }
  };

  //  Date filter
  const filterData = [];
  const [filterGetAllData, setFilterGetAllData] = useState();
  const reqForFilter = () => {
    listTransaction
      ?.filter((data) => {
        console.log("data.createdAt", data.scheduleDate);
        const transactionDate = new Date(data.scheduleDate);
        const startDate = filterStartDate ? new Date(filterStartDate) : null;
        const endDate = filterEndDate ? new Date(filterEndDate) : null;

        // Handle filtering for "Past 7 Days", "Past 30 Days"  "Past 90 Days"
        if (filterDate) {
          return transactionDate >= filterDate;
        }

        if (!startDate && !endDate) {
          return true; // No date range filter, keep the item
        }

        if (startDate && endDate) {
          const isSameDay = startDate.toDateString() === endDate.toDateString();
          if (isSameDay) {
            return transactionDate.toDateString() === startDate.toDateString();
          }
          return (
            (transactionDate >= startDate && transactionDate <= endDate) ||
            transactionDate.toDateString() === startDate.toDateString() ||
            transactionDate.toDateString() === endDate.toDateString()
          );
        }

        if (!startDate && endDate) {
          return transactionDate >= endDate;
        }

        if (startDate && !endDate) {
          return transactionDate <= startDate;
        }
        return false; // Default case, filter out unmatched items
      })
      .map((data) => {
        filterData.push({
          accountId: data.accountId,
          address: data.address,
          afterImages: data.afterImages,
          arrivedDate: data.arrivedDate,
          arrivedStatus: data.arrivedStatus,
          arrivedTime: data.arrivedTime,
          assignedDate: data.assignedDate,
          assignedTime: data.assignedTime,
          bedrooms: data.bedrooms,
          beforeImages: data.beforeImages,
          bookingDate: data.bookingDate,
          bookingId: data.bookingId,
          bookingStatus: data.bookingStatus,
          bookingTime: data.bookingTime,
          cancelBy: data.cancelBy,
          cancelReason: data.cancelReason,
          cancelStatus: data.cancelStatus,
          cartItems: data.cartItems,
          city: data.city,
          cleanerPartnerStatus: data.cleanerPartnerStatus,
          cleanigServiceStatus: data.cleanigServiceStatus,
          companyAddress: data.companyAddress,
          contactPersonName: data.contactPersonName,
          contactPersonNumber: data.contactPersonNumber,
          contractorPaymentId: data.contractorPaymentId,
          contractorid: data.contractorid,
          couponCode: data.couponCode,
          couponId: data.couponId,
          couponType: data.couponType,
          clientName: data.clientName,
          contractorName: data.contractorName,
          createdAt: data.createdAt,
          discount: data.discount,
          dusting: data.dusting,
          dustingPrice: data.dustingPrice,
          fees: data.fees,
          floors: data.floors,
          id: data.id,
          industry: data.industry,
          moppingCleaning: data.moppingCleaning,
          moppingCleaningPrice: data.moppingCleaningPrice,
          otp: data.otp,
          otpAccess: data.otpAccess,
          paymentMethod: data.paymentMethod,
          postalCode: data.postalCode,
          price: data.price,
          recurring: data.recurring,
          reviewReating: data.reviewReating,
          reviewText: data.reviewText,
          scheduleDate: data.scheduleDate,
          scheduleTime: data.scheduleTime,
          serviceType: data.serviceType,
          squireFeet: data.squireFeet,
          subTotal: data.subTotal,
          total: data.total,
          updatedAt: data.updatedAt,
          userPaymentId: data.userPaymentId,
          vacummCleaning: data.vacummCleaning,
          vacummCleaningPrice: data.vacummCleaningPrice,

          // New Parametters
          refundStatus: data.refundStatus,
          workStartedStatus: data.workStartedStatus,
          workCompleteStatus: data.workCompleteStatus,
        });
      });

    // Check if price not null that order showing only
    const filteredReqest = filterData?.filter(
      (booking) => booking?.total !== null
    );

    const bookingsWithStatus = filteredReqest?.map((booking) => {
      let status = "";
      let statusImage = "";
      if (booking.refundStatus === true) {
        status = "Refund";
        statusImage = "./images/icons/status-cancel.svg";
      } else if (booking.cancelStatus === true) {
        status = "Cancelled";
        statusImage = "./images/icons/status-cancel.svg";
      } else if (
        booking.cleaningServiceStatus === "Completed" ||
        booking.bookingStatus === "Completed" ||
        booking.workCompleteStatus === true
      ) {
        status = "Completed";
        statusImage = "./images/icons/status-complete.svg";
      } else if (booking.bookingStatus === "Booking Confirmed") {
        status = "Accepted";
        statusImage = "./images/icons/status-accepted.svg";
      } else {
        status = "Processing";
        statusImage = "./images/icons/status-processing.svg";
      }

      return {
        ...booking,
        status,
        statusImage,
      };
    });
    setFilterGetAllData(bookingsWithStatus);
  };
  useEffect(() => {
    reqForFilter();
  }, [
    selectedPayment,
    selectedType,
    selectedStatus,
    filterDate,
    listTransaction,
    filterStartDate,
    filterEndDate,
  ]);

  // Filter data based on Dropdowns....
  const filterPaymentMethod = (data) => {
    if (!selectedPayment || selectedPayment === "All") {
      return data; // No filtering
    }

    const paidPayment = data.filter(
      (ele) => ele.paymentMethod === "PostPaid" && ele.userPaymentId
    );

    const unpaidPayment = data.filter(
      (ele) => ele.paymentMethod === "PostPaid" && !ele.userPaymentId
    );

    if (selectedPayment == "Paid") {
      return paidPayment;
    }

    if (selectedPayment == "unpaid") {
      return unpaidPayment;
    }
    // const normalizedSelectedPayment = selectedPayment
    //   .toLowerCase()
    //   .replace(/\s+/g, "");
    // return data.filter(
    //   (ele) =>
    //     ele.paymentMethod.toLowerCase().replace(/\s+/g, "") ===
    //     normalizedSelectedPayment
    // );
  };

  const filterTypeData = (data) => {
    if (!selectedType || selectedType == "All") {
      return data;
    }
    return data.filter((ele) => ele.serviceType === selectedType);
  };

  const filterStatusData = (data) => {
    if (!selectedStatus || selectedStatus == "All") {
      return data;
    }
    return data.filter((ele) => ele.status === selectedStatus);
  };

  // Apply filtering in sequence
  const filteredData = filterPaymentMethod(
    filterTypeData(filterStatusData(filterGetAllData))
  );

  const handleDropdownChange = (field) => (value) => {
    if (field === "ApplicationStatus") {
      setApplicationStatus(value);
      const updateApplication = servicePost(
        "adminauth/updateUserInfo",
        {
          id: userDetail?.id,
          postPaidStatus: value,
        },
        notification,
        authToken
      ).then((response) => {
        setCommanModalText("Enterprise Status Updated");
        setShowCommanModal(true);
        setTimeout(() => {
          setCommanModalText("");
          setShowCommanModal(false);
        }, 2000);
      });
    }

    if (field === "serviceType") {
      // setOrderServiceType(value);

      if (value === serviceType) {
        dispatch(setServiceType(value));
        if (value === "Commercial") {
          navigate("/services-commercial", {
            state: { AccountId: AccountId },
          });
        } else {
          navigate("/create-order-services", {
            state: { AccountId: AccountId },
          });
        }
      } else if (value !== serviceType && carts?.length === 0) {
        dispatch(setServiceType(value));
        if (value === "Commercial") {
          dispatch(resetSpecificDropdown(["industry", "floors", "bedrooms"]));
          dispatch(
            resetSpecificFormData(["squareFeet", "otpAccess", "paywith"])
          );
          dispatch(clearFlooringPrices());
          dispatch(emptyCartItem());
          navigate("/services-commercial", {
            state: { AccountId: AccountId },
          });
        } else {
          dispatch(resetSpecificDropdown(["industry", "floors", "bedrooms"]));
          dispatch(
            resetSpecificFormData(["squareFeet", "otpAccess", "paywith"])
          );
          dispatch(clearFlooringPrices());
          dispatch(emptyCartItem());
          navigate("/create-order-services", {
            state: { AccountId: AccountId },
          });
        }
      } else {
        setRedirectPath(
          value === "Commercial"
            ? "/services-commercial"
            : "/create-order-services"
        );
        setShowSpecialityModal(true);
      }
    }

    if (field === "Payment") {
      setSelectedPayment(value);
    }
    if (field === "Type") {
      setSelectedType(value);
    }

    if (field === "Status") {
      setSelectedStatus(value);
    }
  };

  // go to Transation Page
  const goToTxDetail = (data) => {
    navigate("/transation-detail", { state: { bookingId: data.bookingId } });
  };

  return (
    <>
      <SpecialityModal
        show={showSpecialityModal}
        onHide={() => setShowSpecialityModal(false)}
        redirectPath={redirectPath}
        type={
          redirectPath && redirectPath?.includes("commercial")
            ? "Commercial"
            : "Residential"
        }
        clearIndustryData={true}
      />
      <div
        className="offcanvas offcanvas-end offcanvas-custom"
        tabIndex="-1"
        id="disabletwofa"
        aria-labelledby="offcanvasRightLabel"
      >
        <div className="offcanvas-header">
          <h5 id="offcanvasRightLabel"> Two-Factor Authentication </h5>
          {/* <button
            type="button"
            className="btn-close text-reset"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          ></button> */}

          <svg
            className="drawer-cross-icon"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
            xmlns="http://www.w3.org/2000/svg"
            width="38.894"
            height="38.894"
            viewBox="0 0 38.894 38.894"
          >
            <path
              id="Path_18510"
              data-name="Path 18510"
              d="M38.894,18.763v1.367c-.03.2-.066.4-.087.595-.062.577-.087,1.16-.18,1.732a18.957,18.957,0,0,1-4.2,9.313,19.088,19.088,0,0,1-12.867,6.963c-.475.055-.95.107-1.425.161H18.763c-.589-.06-1.18-.1-1.766-.184A19.039,19.039,0,0,1,7.48,34.7,19.112,19.112,0,0,1,.16,21.555Q.08,20.881,0,20.207V18.687c.029-.173.064-.345.087-.518.115-.875.165-1.764.349-2.624A19.178,19.178,0,0,1,8.516,3.423,18.658,18.658,0,0,1,17.3.163C17.788.11,18.275.054,18.763,0h1.367c.173.028.346.065.52.083.6.062,1.212.082,1.808.181A19.116,19.116,0,0,1,32.821,5.4a19.035,19.035,0,0,1,5.913,11.935q.08.712.16,1.425m-21.765.7c-.32.306-.617.579-.9.863q-1.963,1.957-3.92,3.921A1.655,1.655,0,0,0,13.23,27.1a1.668,1.668,0,0,0,1.464-.56q2.226-2.232,4.457-4.458c.1-.1.2-.185.348-.327a3.961,3.961,0,0,0,.281.359q2.225,2.232,4.457,4.458a1.628,1.628,0,0,0,2.109.283,1.645,1.645,0,0,0,.231-2.615c-1.487-1.5-2.987-2.992-4.481-4.487-.1-.1-.186-.2-.321-.344.238-.221.465-.42.679-.633q2.057-2.051,4.108-4.109a1.655,1.655,0,1,0-2.334-2.34q-2.248,2.236-4.486,4.483c-.095.095-.2.184-.315.294-.892-.9-1.756-1.771-2.622-2.64-.724-.726-1.446-1.454-2.177-2.173a1.583,1.583,0,0,0-1.7-.431,1.6,1.6,0,0,0-1.131,1.352,1.651,1.651,0,0,0,.547,1.467c1.577,1.573,3.151,3.149,4.789,4.787"
              fill="#00A19B"
            />
          </svg>
        </div>
        <div className="offcanvas-body">
          <TwofaDisableDrawer userEmail={userDetail?.Email} />
        </div>
      </div>
      <Navbar />
      <div className="account-detail-main-wrapper">
        <ConfirmationModal
          show={modalShow}
          onHide={() => setModalShow(false)}
          type="Are you sure to change the status of this transaction"
          selectedtablestatus={selectedTableStatus}
          transactionid={transactionId}
        />
        <KYCResetModal
          show={kycmodalShow}
          onHide={() => setkycModalShow(false)}
          type="Are you sure to change the status of KYC"
          accountId={AccountId}
        />

        <CommonModal
          show={showCommanModal}
          onHide={() => setShowCommanModal(false)}
          type={commanModalText}
        />

        <Sidebar />
        <div className="container">
          <div className="spacing-wrapper">
            <div className="account-detail-header">
              <div className="account-header-left">
                <img src="./images/icons/admin-user-icon.png" alt="icon" />
                {checkedIp == "customer" ? (
                  <h2 className="account-detail-Txt">
                    {" "}
                    Account/Client/Details{" "}
                  </h2>
                ) : (
                  <h2 className="account-detail-Txt"> Account Transactions </h2>
                )}
              </div>

              <div className="ip-whitelist-switch-wrapper">
                <div class="switches-container">
                  <input
                    type="radio"
                    id="switchMonthly"
                    name="switchPlan"
                    value="Monthly"
                    checked={checkedIp == "customer" ? true : false}
                    onChange={() => setCheckedIp("customer")}
                  />
                  <input
                    type="radio"
                    id="switchYearly"
                    name="switchPlan"
                    value="Yearly"
                    checked={checkedIp == "transaction" ? true : false}
                    onChange={() => setCheckedIp("transaction")}
                  />
                  <label for="switchMonthly"> User Details </label>
                  <label for="switchYearly"> Account Transactions </label>
                  <div class="switch-wrapper">
                    <div class="switch">
                      <div>User Details </div>
                      <div> Account Transactions </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {checkedIp == "customer" && (
              <>
                <div className="account-detail-profile-wrapper">
                  <div className="account-profile-head">
                    <img
                      onClick={goToAccount}
                      src="./images/icons/back-arrow.svg"
                      alt="arrow"
                    />
                    <h3> Profile</h3>

                    {/* <div className="profile-edit-button">
                      <p> Edit </p>
                      <img src="./images/icons/edit-icon.svg" alt="icon" />
                    </div> */}
                  </div>

                  <div className="account-detail-profile-wrap">
                    {shimmerLoading ? (
                      <>
                        <div className="shimmer-account-profile-info">
                          <ShimmerCircularImage />
                          <ShimmerText line={8} gap={20} />
                        </div>
                      </>
                    ) : (
                      <div className="account-profile-left">
                        <div className="account-profile">
                          <img
                            src={
                              userDetail?.profileImageURL
                                ? userDetail?.profileImageURL
                                : "./images/default-profile.png"
                            }
                            alt="profile"
                          />
                        </div>

                        <div className="account-profile-info">
                          <div className="username">
                            <h3>
                              {userDetail?.fullName == null ? (
                                <h3> {userDetail?.email.slice(0, 7)}.... </h3>
                              ) : (
                                <h3>{userDetail?.fullName}</h3>
                              )}
                              {/* Daniel Raissar */}
                            </h3>
                            <p>{userDetail?.email}</p>
                          </div>

                          <div className="account-info-wrapper">
                            <div className="account-info-wrap">
                              <h4>Number :</h4>
                              <h5>{userDetail?.phone}</h5>
                            </div>

                            <div className="account-info-wrap">
                              <h4>Last login Time : </h4>
                              <h5>
                                {moment(
                                  listActivity && listActivity[0]?.Time
                                ).format("l")}{" "}
                                <span className="time">
                                  {" "}
                                  {moment(
                                    listActivity && listActivity[0]?.Time
                                  ).format("h:mm:ss a")}{" "}
                                </span>
                              </h5>
                            </div>

                            {/* <div className="account-info-wrap">
                            <h4> Status :</h4>
                            <h5>
                              Panding Kyc */}
                            {/* {userDetail?.kycStatus === "REJECT" && (
                                <>
                                  <h3>Rejected</h3>

                                  <button
                                    onClick={resetKYC}
                                    aria-controls="customizeDatecanvasRight"
                                    className="btn"
                                    type="button"
                                  >
                                    Click to reset
                                  </button>
                                </>
                              )}
                              {userDetail?.kycStatus === "APPROVE" &&
                                "Complete KYC"}
                              {userDetail?.kycStatus === null && "Pending KYC"} */}
                            {/* </h5>
                          </div> */}

                            <div className="account-info-wrap">
                              <h4>Account Created :</h4>
                              <h5>
                                {moment(userDetail?.createdAt).format("l")}{" "}
                              </h5>
                            </div>

                            <div className="account-info-wrap">
                              <h4>Postpaid Form :</h4>
                              {userDetail?.postPaidDoc ? (
                                <button>
                                  <a
                                    href={userDetail?.postPaidDoc}
                                    target="_blank"
                                  >
                                    View Doc
                                  </a>
                                </button>
                              ) : (
                                <h5> Not uploaded</h5>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    )}

                    <div className="account-profile-right">
                      <div className="account-edit-profile-right">
                        <div className="profile-edit-application-dropdown create-order-dropdwon">
                          {shimmerLoading ? (
                            <ShimmerThumbnail rounded />
                          ) : (
                            userDetail?.postPaidDoc && (
                              <Dropdown
                                onTypeChange={handleDropdownChange(
                                  "ApplicationStatus"
                                )}
                                label="Enterprise"
                                data={ApplicationStatusDropdown}
                                alreadyValue={
                                  userDetail?.postPaidStatus
                                    ? userDetail?.postPaidStatus
                                    : ""
                                }
                              />
                            )
                          )}
                        </div>
                        {shimmerLoading ? (
                          <div className="profile-edit-application-dropdown">
                            <ShimmerThumbnail rounded />
                          </div>
                        ) : (
                          userDetail?.postPaidStatus == "Approved" && (
                            <div className="profile-edit-application-dropdown create-order-dropdwon">
                              <Dropdown
                                onTypeChange={handleDropdownChange(
                                  "serviceType"
                                )}
                                label="Create order"
                                data={CreateServiceData}
                              />
                            </div>
                          )
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="profile-activity-wrapper table-responsive">
                  <h2> Recent Activity</h2>

                  <div className="profile-activity-table table-responsive">
                    {/* <ProfileTable /> */}

                    <table id="accountProfile" className="table table-striped">
                      <thead>
                        <tr>
                          <th style={{ width: "80px" }}>Email</th>
                          <th style={{ width: "80px" }}>IpAddress</th>
                          <th style={{ width: "80px" }}>Browser</th>
                          <th style={{ width: "120px" }}>Date</th>
                        </tr>
                      </thead>
                      <tbody style={{ textAlign: "center" }}>
                        {shimmerLoading ? (
                          <tr>
                            <td colSpan={5}>
                              {Array.from({ length: 10 }).map((_, index) => (
                                <div
                                  className="shimmer-table-main-wrap"
                                  key={index}
                                >
                                  <ShimmerTable row={0} col={4} />
                                </div>
                              ))}
                            </td>
                          </tr>
                        ) : listActivity?.length > 0 ? (
                          listActivity.map((data, index) => {
                            return (
                              <tr key={index}>
                                <td>{data.email}</td>
                                <td>{data.ipaddress}</td>
                                <td>
                                  {data.browser
                                    ? getDeviceInfo(data.browser)
                                    : "--"}
                                </td>
                                <td>
                                  {moment(data.createdAt).format("DD-MMM-YYYY")}
                                </td>
                              </tr>
                            );
                          })
                        ) : (
                          <tr>
                            <td colSpan={5}> No Data Found</td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </>
            )}

            {checkedIp == "transaction" && (
              <>
                <div
                  className="offcanvas offcanvas-end offcanvas-custom"
                  tabIndex="-1"
                  id="customizeDatecanvasRight"
                  aria-labelledby="offcanvasRightLabel"
                >
                  <div className="offcanvas-header">
                    <h5 id="offcanvasRightLabel">Customize time range</h5>

                    <svg
                      className="drawer-cross-icon"
                      data-bs-dismiss="offcanvas"
                      aria-label="Close"
                      xmlns="http://www.w3.org/2000/svg"
                      width="38.894"
                      height="38.894"
                      viewBox="0 0 38.894 38.894"
                    >
                      <path
                        id="Path_18510"
                        data-name="Path 18510"
                        d="M38.894,18.763v1.367c-.03.2-.066.4-.087.595-.062.577-.087,1.16-.18,1.732a18.957,18.957,0,0,1-4.2,9.313,19.088,19.088,0,0,1-12.867,6.963c-.475.055-.95.107-1.425.161H18.763c-.589-.06-1.18-.1-1.766-.184A19.039,19.039,0,0,1,7.48,34.7,19.112,19.112,0,0,1,.16,21.555Q.08,20.881,0,20.207V18.687c.029-.173.064-.345.087-.518.115-.875.165-1.764.349-2.624A19.178,19.178,0,0,1,8.516,3.423,18.658,18.658,0,0,1,17.3.163C17.788.11,18.275.054,18.763,0h1.367c.173.028.346.065.52.083.6.062,1.212.082,1.808.181A19.116,19.116,0,0,1,32.821,5.4a19.035,19.035,0,0,1,5.913,11.935q.08.712.16,1.425m-21.765.7c-.32.306-.617.579-.9.863q-1.963,1.957-3.92,3.921A1.655,1.655,0,0,0,13.23,27.1a1.668,1.668,0,0,0,1.464-.56q2.226-2.232,4.457-4.458c.1-.1.2-.185.348-.327a3.961,3.961,0,0,0,.281.359q2.225,2.232,4.457,4.458a1.628,1.628,0,0,0,2.109.283,1.645,1.645,0,0,0,.231-2.615c-1.487-1.5-2.987-2.992-4.481-4.487-.1-.1-.186-.2-.321-.344.238-.221.465-.42.679-.633q2.057-2.051,4.108-4.109a1.655,1.655,0,1,0-2.334-2.34q-2.248,2.236-4.486,4.483c-.095.095-.2.184-.315.294-.892-.9-1.756-1.771-2.622-2.64-.724-.726-1.446-1.454-2.177-2.173a1.583,1.583,0,0,0-1.7-.431,1.6,1.6,0,0,0-1.131,1.352,1.651,1.651,0,0,0,.547,1.467c1.577,1.573,3.151,3.149,4.789,4.787"
                        fill="#00A19B"
                      />
                    </svg>
                  </div>
                  <div className="offcanvas-body">
                    <CustomizeTime
                      setFilterStartDate={setFilterStartDate}
                      setFilterEndDate={setFilterEndDate}
                      filterStartDate={filterStartDate}
                      filterEndDate={filterEndDate}
                    />
                  </div>
                </div>

                <div
                  className="offcanvas offcanvas-end offcanvas-custom"
                  tabIndex="-1"
                  id="filtercanvasRight"
                  aria-labelledby="offcanvasRightLabel"
                >
                  <div className="offcanvas-header">
                    <h5 id="offcanvasRightLabel">Filters</h5>

                    <svg
                      className="drawer-cross-icon"
                      data-bs-dismiss="offcanvas"
                      aria-label="Close"
                      xmlns="http://www.w3.org/2000/svg"
                      width="38.894"
                      height="38.894"
                      viewBox="0 0 38.894 38.894"
                    >
                      <path
                        id="Path_18510"
                        data-name="Path 18510"
                        d="M38.894,18.763v1.367c-.03.2-.066.4-.087.595-.062.577-.087,1.16-.18,1.732a18.957,18.957,0,0,1-4.2,9.313,19.088,19.088,0,0,1-12.867,6.963c-.475.055-.95.107-1.425.161H18.763c-.589-.06-1.18-.1-1.766-.184A19.039,19.039,0,0,1,7.48,34.7,19.112,19.112,0,0,1,.16,21.555Q.08,20.881,0,20.207V18.687c.029-.173.064-.345.087-.518.115-.875.165-1.764.349-2.624A19.178,19.178,0,0,1,8.516,3.423,18.658,18.658,0,0,1,17.3.163C17.788.11,18.275.054,18.763,0h1.367c.173.028.346.065.52.083.6.062,1.212.082,1.808.181A19.116,19.116,0,0,1,32.821,5.4a19.035,19.035,0,0,1,5.913,11.935q.08.712.16,1.425m-21.765.7c-.32.306-.617.579-.9.863q-1.963,1.957-3.92,3.921A1.655,1.655,0,0,0,13.23,27.1a1.668,1.668,0,0,0,1.464-.56q2.226-2.232,4.457-4.458c.1-.1.2-.185.348-.327a3.961,3.961,0,0,0,.281.359q2.225,2.232,4.457,4.458a1.628,1.628,0,0,0,2.109.283,1.645,1.645,0,0,0,.231-2.615c-1.487-1.5-2.987-2.992-4.481-4.487-.1-.1-.186-.2-.321-.344.238-.221.465-.42.679-.633q2.057-2.051,4.108-4.109a1.655,1.655,0,1,0-2.334-2.34q-2.248,2.236-4.486,4.483c-.095.095-.2.184-.315.294-.892-.9-1.756-1.771-2.622-2.64-.724-.726-1.446-1.454-2.177-2.173a1.583,1.583,0,0,0-1.7-.431,1.6,1.6,0,0,0-1.131,1.352,1.651,1.651,0,0,0,.547,1.467c1.577,1.573,3.151,3.149,4.789,4.787"
                        fill="#00A19B"
                      />
                    </svg>
                  </div>
                  <div className="offcanvas-body">
                    <div className="mobile-filter-drawer-wrapper">
                      <div className="mobile-filter-drawer-wrap filter-select-wraper">
                        <DateFilter onTypeChange={handleDateChange} />
                        <Dropdown
                          onTypeChange={handleDropdownChange("Payment")}
                          label="Payment"
                          data={paymentDropData}
                        />

                        <Dropdown
                          onTypeChange={handleDropdownChange("Type")}
                          label="Type"
                          data={TypeDropData}
                        />

                        <Dropdown
                          onTypeChange={handleDropdownChange("Status")}
                          label="Status"
                          data={StatusDropdown}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="fiter-dropdown">
                  <div className="filter-select-wraper">
                    <DateFilter onTypeChange={handleDateChange} />
                    <Dropdown
                      onTypeChange={handleDropdownChange("Payment")}
                      label="Payment"
                      data={paymentDropData}
                    />

                    <Dropdown
                      onTypeChange={handleDropdownChange("Type")}
                      label="Type"
                      data={TypeDropData}
                    />

                    <Dropdown
                      onTypeChange={handleDropdownChange("Status")}
                      label="Status"
                      data={StatusDropdown}
                    />
                  </div>
                </div>

                <div className="fiter-dropdown-mobile">
                  <div
                    className="mobile-filter-wrap"
                    data-bs-toggle="offcanvas"
                    data-bs-target="#filtercanvasRight"
                    aria-controls="filtercanvasRight"
                  >
                    <h3> Filters</h3>
                    <div>
                      <img src={Filtericon} alt="icon" />
                    </div>
                  </div>
                </div>
                <div className="tranfer-history-dropdown-wrapper table-responsive">
                  <span
                    id="customizedate"
                    data-bs-toggle="offcanvas"
                    data-bs-target="#customizeDatecanvasRight"
                    aria-controls="customizeDatecanvasRight"
                  ></span>

                  <table id="transfer" className="table table-striped">
                    <thead>
                      <tr>
                        <th> Transaction Id </th>
                        {/* <th style={{ width: "100px" }}>Tx no.</th> */}
                        <th> Schedule </th>
                        <th> Amount </th>
                        <th> Cleaner </th>
                        <th> Type </th>
                        <th> Payment </th>
                        {/* <th> Payout </th> */}
                        <th> Status </th>
                        <th> View </th>
                      </tr>
                    </thead>

                    <tbody>
                      {filteredData?.length > 0 ? (
                        filteredData.map((data, index) => (
                          <tr key={index}>
                            <td>{data.bookingId}</td>
                            {/* <td style={{ width: "100px" }}>{data.txno}</td> */}
                            <td>
                              {moment(data.scheduleDate).format("DD MMM, YYYY")}
                            </td>
                            <td>${data.total}</td>
                            <td>
                              {data.contractorName ? data.contractorName : "--"}
                            </td>

                            <td>
                              <div className="table-status-icon">
                                {data.serviceType == "Residential" ? (
                                  <img
                                    className="type-icon-wrap"
                                    src="./images/icons/type-icon.png"
                                    alt="icon"
                                  />
                                ) : (
                                  <img
                                    className="type-icon-wrap"
                                    src="./images/icons/type-commercial.png"
                                    alt="icon"
                                  />
                                )}
                              </div>
                            </td>
                            <td>
                              <div className="table-status-icon">
                                {data.paymentMethod == "Credit Card" ? (
                                  <img
                                    src="./images/icons/card-icon.png"
                                    alt="icon"
                                  />
                                ) : (
                                  <img
                                    className="table-postpaid-icon"
                                    src="./images/icons/postpaid-icon.png"
                                    alt="icon"
                                  />
                                )}
                              </div>
                            </td>
                            {/* <td>
                              {data.userPaymentId ? data.userPaymentId : "-"}
                            </td> */}
                            <td>
                              <div className="table-status-icon1">
                                <img src={data.statusImage} alt="icon" />
                              </div>
                            </td>
                            <td>
                              <img
                                className="table-view-icon"
                                onClick={() => goToTxDetail(data)}
                                style={{ cursor: "pointer" }}
                                src="./images/icons/view-icon.svg"
                                alt="icon"
                              />
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="8">No Data Found</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default AccountDetail;
